import { render, staticRenderFns } from "./TemplateImages.vue?vue&type=template&id=3db6d47e&scoped=true"
import script from "./TemplateImages.vue?vue&type=script&lang=js"
export * from "./TemplateImages.vue?vue&type=script&lang=js"
import style0 from "./TemplateImages.vue?vue&type=style&index=0&id=3db6d47e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db6d47e",
  null
  
)

export default component.exports